// @flow

import {
  SEARCH_QUERY_ON_CHANGE,
  GET_RECENT_POLICY_MERCHANT_SUCCESS,
} from '../constants'

const initialState = {
  query: '',
  recentPolicy: [],
  error: ''
}

type State = {
  query: string,
  recentPolicy: Array<{}>,
  error: string,
}

type Action = {
  type: string,
  payload: any,
}

function merchant(state: State = initialState, action: Action) {
  switch (action.type) {
    case SEARCH_QUERY_ON_CHANGE:
      return {
        ...state,
        query: action.payload
      }
    case GET_RECENT_POLICY_MERCHANT_SUCCESS:
      return {
        ...state,
        recentPolicy: action.payload.result.policies
      }
    default:
      return state
  }
}

export default merchant



// WEBPACK FOOTER //
// ./src/modules/merchant.js